import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { dbSelectorSchema } from '../../lib/db-selector';
import { SqlService } from '../../service';

export type BackupsConfig = typeof BackupsConfig._.Config;

export const BackupsConfig = IntegrationConfig.make({
  service: SqlService,
  name: Integration_Handler_Names_Enum.Backups,
  configSchema: z.object({
    dbSelectors: z.array(dbSelectorSchema).min(1),
    maxDaysSinceLastBackup: z.number().positive().optional(),
  }),
});
